/**
 * Language switcher, React edition of ui/LanguageSwitcher.ts.
 *
 * Still a real <select> with the app's own styling rather than an antd
 * Select: the native control is what makes it work on the entry screen with
 * zero JS overhead, names every language in itself, and the styling already
 * exists. Deliberately always visible - a student who cannot read the
 * interface cannot find the menu that would fix it.
 */

import { LANGUAGE_LABELS, LANGUAGES, setLanguage, t, type Language } from '../../i18n/i18n'
import { useLang } from '../i18n/LanguageProvider'

export function LanguageSwitch() {
  const lang = useLang()
  const label = t('language.Change')
  return (
    <div
      className="lang-switch"
      // The whole entry screen is a click target for entering the cleanroom,
      // so opening the menu must not also walk the student through the door.
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <select
        className="lang-select"
        aria-label={label}
        title={label}
        value={lang}
        onChange={(e) => {
          void setLanguage(e.target.value as Language)
        }}
      >
        {LANGUAGES.map((l) => (
          <option key={l} value={l}>
            {LANGUAGE_LABELS[l]}
          </option>
        ))}
      </select>
    </div>
  )
}
